
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

import datePick from '../common/datePick.vue'
import personPick from '../common/personPick.vue'
import Agreement from '../common/Agreement.vue'
import choosePerson from '../common/choosePerson.vue'
var DEBOUNCE_TIME = 400;
export default{
components:{
Group,
Cell,
XInput,
Badge,
XButton,
Icon,
PopupPicker,
datePick,
personPick,
choosePerson,
Agreement
},
data(){
return{
upvalue:'',
initStation:"",
downvalue:'',
jsDate:"今天11点15分",     //实际时间
jspickerDate:[], //pick时间
showPickerPerson:false, //pick显示
personList:[[1, 2, 3, 4, 5]], //pick数据
jspickerPerson:[],
jsPerson:sessionStorage.getItem('jbpersonNum') || '1',
jsPassanger:'卢梅  177****8888',
defaultFlag: true,
checkBoxFlag: true,
checkBoxValue:'success',
showPopupPicker:false,
list3: [],
payPrice:"",
activityName:"",
showAgree:false,
ProtocolDetail:"",
}
},
watch:{
'checkBoxFlag':function(newValue, oldValue){
this.checkBoxValue =newValue?'success':'circle';
},
upvalue:function(newValue, oldValue){
if(this.downvalue && newValue.cityNo !=  this.downvalue.cityNo) {
this.$vux.toast.show({
text: "当前下车地点和上车地点不在同一服务区,请重新选择",
type:"text"
});
this.downvalue = "";
var jbStorage = JSON.parse(window.localStorage.getItem("jbStorage"));
if(jbStorage){
jbStorage.downvalue = "";
jbStorage.city = "";
window.localStorage.setItem("jbStorage",JSON.stringify(jbStorage));
}
return;
}
},
"downvalue":function(newValue, oldValue){
if(this.upvalue&&newValue.cityNo !=  this.upvalue.cityNo) {
this.upvalue = "";
this.$vux.toast.show({
text: "当前上车地点和下车地点不在同一服务区,请重新选择",
type:"text"
});
var jbStorage = JSON.parse(window.localStorage.getItem("jbStorage"));
if(jbStorage){
jbStorage.mapAddress = "";
window.localStorage.setItem("jbStorage",JSON.stringify(jbStorage));
}

return;
}
this.bindDateAndPerson(newValue.cityNo);

},
"jsDate":function(newValue,oldValue){
setTimeout(()=>{
this.callPrice();
},300)
}
},
methods:{
yz(val){
return this.$until.yzFontColor(val);
},
queryProtocolDetail(){
this.$http.post(window.innerAPI + "?server=queryProtocolDetail", {
code: 'p_shuttle'
}).then(res => {
this.ProtocolDetail = res.data.data.content
}).catch(err => {
});
},

selectUpvalue(){
var labelflag =  1; 
if(localStorage.getItem("$currentCity") != this.upvalue.cityNo){
labelflag = 0;
}
var cityNo = this.upvalue.cityNo||"";
this.$router.push("/arriveAddressB?label="+labelflag+"&cityNo="+cityNo);
},

selectDownvalue(){
if(!this.upvalue){
this.$vux.toast.show({
text: "请选择上车地点",
type:"text"
});
return;
}
var cityNo =  this.downvalue ? this.downvalue.cityNo : (this.upvalue?this.upvalue.cityNo:"");
var cityName =  this.downvalue ? this.downvalue.cityName :(this.upvalue?this.upvalue.cityName:"");
this.$router.push("/address?cityNo="+cityNo+"&cityName="+cityName);
},

bindDateAndPerson(cityNo){
var that =  this;
this.$until.getDateTime(this, cityNo).then(function(data){
that.list3 =  data.jspickerDate;
that.personList =  [data.personList];
})
},

initUpValue(){

var currPoint = this.$store.state.mutations.currentPoint, that =  this, upvalue =  window.localStorage.getItem("jbStorage");

if(upvalue){
upvalue =  JSON.parse(upvalue);
if(upvalue.mapAddress){
this.upvalue =  upvalue.mapAddress;
upvalue.cityName = upvalue.mapAddress.cityName;

this.setdownvalue();
return;
}
}

if(currPoint){
currPoint =  currPoint.split(",");

that.initStationFun(currPoint).then(function (result) {
if(result.data.data.cityNo === that.$store.state.mutations.cityNo){
that.$until.checkCurrPoint(that, currPoint.join(",")).then(function (res) {



if(res.data.data.data == "0") {
that.setUpPoint(0);
return;
}
if(res.data.data.code) {
that.setUpPoint(0);
return;
}




that.setUpPoint(1,currPoint,res);
}, function (err) {
reject("请求失败");
})
}

});


}else{

var map =  this.$store.state.mutations.map;
var geolocation = new BMap.Geolocation();

geolocation.getCurrentPosition(function(r){
if(this.getStatus() == BMAP_STATUS_SUCCESS){
currPoint = [r.point.lng, r.point.lat];


that.initStationFun(currPoint).then(function (result) {
if(result.data.data.cityNo === that.$store.state.mutations.cityNo){
that.$until.checkCurrPoint(that, r.point.lng + "," + r.point.lat).then(function (res) {



if(res.data.data.data == "0") {
that.setUpPoint(0);
return;
}
if(res.data.data.code) {
that.setUpPoint(0);
return;
}

that.setUpPoint(1,currPoint,res);
}, function (err) {
reject("请求失败");
})
}

});

}else{
that.$store.dispatch('hideLoading'); 
that.$vux.toast.show({
text: "定位失败,请选择上车地点",
type:"text"
});
}
},{enableHighAccuracy: true})
}
},

setUpPoint(flag,currPoint,cityNo){
if(!flag) {
/* this.$vux.toast.show({
text: "不在服务区，请选择上车点",
type:"text"
});*/
this.upvalue = "";
this.$store.dispatch('hideLoading');
return;
}


var geoc = new BMap.Geocoder(), that =  this;
var point = new BMap.Point(currPoint[0],currPoint[1]);


geoc.getLocation(point, function(rs){
that.upvalue =  {
point:rs.point,
address:rs.address,
cityName: rs.addressComponents.city,
cityNo: cityNo.data.data.data

};
that.$store.dispatch('hideLoading'); 

window.localStorage.setItem("jbStorage",JSON.stringify({
mapAddress: that.upvalue,
cityName: rs.addressComponents.city,
}));
that.setdownvalue(currPoint);
});

},

callPrice(){
if(!this.upvalue || !this.downvalue|| !this.jsDate){

return;
}
this.$http.post(window.innerAPI + "?server=queryShuttlePrice",{
"bizTypeStr":"3",
"upPoint":this.upvalue.point.lat+","+this.upvalue.point.lng,
"endSiteNo": this.downvalue.siteNo,
"numbers": this.jsPerson,
"useDate":this.$until.updateDate(this.jsDate),
"userToken": window.localStorage.getItem("cdqcp_opid"),
}).then(res=>{
this.payPrice =  res.data.data.data.notCarpoolPayPrice;
this.activityName =  res.data.data.data.details[0].activityName;
}).catch(err=>{

});
},

setdownvalue(point){
var jbStorage =  window.localStorage.getItem("jbStorage"),_this = this;
if(!point){

if(jbStorage){ this.downvalue = JSON.parse(jbStorage).downvalue ? JSON.parse(jbStorage).downvalue: "";}
return;
}
let jsShuttleInfo = JSON.parse(localStorage.getItem('jbShuttleInfo'));
if(jsShuttleInfo&&JSON.parse(jbStorage)){
jbStorage = JSON.parse(jbStorage);
jbStorage.downvalue = jsShuttleInfo.upvalue;
this.downvalue = jsShuttleInfo.upvalue;
localStorage.setItem('jbStorage',JSON.stringify(jbStorage));
return false;
}
this.$http.post(window.innerAPI + "?server=initStation", {
"ip": "171.88.164.17",
"point":point.join(","),
"channelCode":localStorage.getItem('useCar_jb_channelCode')
}).then(res => {
if(res.data.data.code){
this.downvalue = "";
this.$store.dispatch('hideLoading');
return;
}
if (res.data.data) {

if(this.upvalue.cityNo != res.data.data.cityNo){
this.upvalue = "";
localStorage.removeItem("jbStorage");
this.$store.dispatch('hideLoading')
return;
}
this.downvalue =  res.data.data;
this.$store.dispatch('hideLoading')
var jbStorage = window.localStorage.getItem("jbStorage")

if(jbStorage){
jbStorage =  JSON.parse(jbStorage);
jbStorage.downvalue = res.data.data;
window.localStorage.setItem("jbStorage",JSON.stringify(jbStorage));
return;
}
window.localStorage.setItem("jbStorage",JSON.stringify({"downvalue":res.data.data}));
}
}).catch(function (errr) {
_this.$store.dispatch('hideLoading')

})
},

init(){


this.initUpValue();
},

comfirmOrder(){
if(!this.upvalue ||!this.downvalue || !this.jsDate || !this.jsPerson || !this.jsPassanger){
this.$vux.toast.show({
text: "请完善订单信息",
type:"text"
})
return;
}else if(!this.checkBoxFlag){
this.$vux.toast.show({
text: "请同意服务协议",
type:"text"
})
return;
}else if(this.upvalue.cityNo != this.downvalue.cityNo){
this.$vux.toast.show({
text: "起止点不在同一城市，请重新设置",
type:"text"
})
return;
}
var arr = [];
for(var i = 0; i < this.jsPerson; i++){
arr.push({});
}
window.clearTimeout(this.tId);
var _p_from = this.$until.judgeBrowser();
this.tId =  setTimeout(()=>{

this.$http.post(window.innerAPI + "?server=initOrder",{
"bizType":"3",
"shiftNo":"1111",
"lineSiteEndNo": this.downvalue.siteNo,
"numbers": this.jsPerson[0],
"bookDate":this.$until.updateDate(this.jsDate).split(" ")[0],
"driverTime": this.$until.updateDate(this.jsDate).split(" ")[1],
"contactMobile": this.jsPassanger.split(" ")[1],
"contactName": this.jsPassanger.split(" ")[0],
"downAddress": this.downvalue.siteName,
"upAddress": this.upvalue.address,
"userToken": window.localStorage.getItem("cdqcp_opid"),
"upPoint":this.upvalue.point.lat+","+this.upvalue.point.lng,
"passengersStr":JSON.stringify(arr),
"_p_from":_p_from
}).then(res=>{
if(res.data.data.code == "30000"){
this.$vux.toast.show({
text: res.data.data.errmsg,
type: "text"
});
return;
}
if(res.data.msg){
this.$vux.toast.show({
text: res.data.msg,
type: "text"
});
return;
}
if(res.data.data.code){
this.$vux.toast.show({
text: "下单失败",
type: "text"
});
return;
}
if(res.data.data){
this.$until.getBackUrl(this, res.data.data.orderNo);

}
}).catch(err=>{

});
},DEBOUNCE_TIME)

},
initStationFun(point){

return new Promise((resolve,reject) => {
this.$http.post(window.innerAPI + "?server=initStation", {
"ip": "171.88.164.17",
"point":point.join(","),
"channelCode":localStorage.getItem('useCar_jb_channelCode')
}).then(res => {
resolve(res);
});
})
}
},
activated(){
this.payPrice = "";
this.downvalue = "";
this.upvalue = "";
this.$store.state.mutations.path =  "giveawayStation";
this.$store.state.mutations.cityAddress =  true;
this.init();
},
beforeCreate() {
let me = this;
if(this.$until.getUrlParam('stationName')){
let shuttleInfo = {
cityName:'',
jsPassageValue:'',
jsPassager:'',
currentPoint: this.$until.getUrlParam('stationLng') + "," + this.$until.getUrlParam('stationLat'),
upvalue: {
cityName:'',
cityNo:me.$until.getUrlParam('targetNo'),
enCityName:'',
enName:'',
siteName:me.$until.getUrlParam('stationName'),
siteNo:me.$until.getUrlParam('stationNo')
}
};
localStorage.setItem('jbShuttleInfo', JSON.stringify(shuttleInfo));
}else {
localStorage.removeItem('jbShuttleInfo');
}
},
mounted(){
this.payPrice = "";
this.downvalue = "";
this.upvalue = "";
this.$store.state.mutations.cityNo = this.$until.getUrlParam('targetNo');
this.queryProtocolDetail();
}
}



// WEBPACK FOOTER //
// ./src/components/pickGiveStation/giveawayStation.vue